__turbopack_context__.v({
  "clocButton": "Button-module__xaXzvq__clocButton",
  "clocButtonFill": "Button-module__xaXzvq__clocButtonFill",
  "clocButtonText": "Button-module__xaXzvq__clocButtonText",
  "clocButtonWrapper": "Button-module__xaXzvq__clocButtonWrapper",
});
